export abstract class PolicyDocumentService {
  abstract downloadMembershipCard(cb: (blob: Blob) => void): any;
  abstract downloadPolicy(cb: (blob: Blob) => void): any;
  abstract downloadTermsAndConditions(): any;

  abstract uploadMembershipCard(cb: () => void): void;
  abstract uploadPolicy(cb: () => void): void;
}